import { render, staticRenderFns } from "./FenceDraw.vue?vue&type=template&id=2a2879b4&scoped=true"
import script from "./FenceDraw.vue?vue&type=script&lang=js"
export * from "./FenceDraw.vue?vue&type=script&lang=js"
import style0 from "./FenceDraw.vue?vue&type=style&index=0&id=2a2879b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2879b4",
  null
  
)

export default component.exports